import React from 'react';

function MaterialIcon({ name, filled = false, className = '', size = 24 }) {
  return (
    <span
      className={`material-symbols-outlined ${filled ? 'filled' : ''} ${className}`}
      style={{ fontSize: size }}
    >
      {name}
    </span>
  );
}

export default MaterialIcon;
